export const createActionCreator = (type) => (payload) => ({ type, payload });